module.exports = __webpack_public_path__ + "prod/1.42.2/img/bannerForm2.b426234c.png";